import useWebChatUIContext from '/druid/internal/useWebChatUIContext';

export default function useStyleSet(): [any] {
  return [useWebChatUIContext().styleSet];
}
